var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modern-notice"},[_c('div',{staticClass:"notice-container"},[_vm._m(0),_c('div',{staticClass:"notice-content"},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('div',{key:_vm.text.id,staticClass:"notice-text"},[_vm._v(" "+_vm._s(_vm.text.val)+" ")])])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-icon"},[_c('i',{staticClass:"el-icon-mic"})])
}]

export { render, staticRenderFns }